/**
 * @generated SignedSource<<d00ab72a89e903fbb80c3e9c8989153b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskCopilotPanel_useAskCopilotSendMessage_note$data = {
  readonly id: string;
  readonly " $fragmentType": "AskCopilotPanel_useAskCopilotSendMessage_note";
};
export type AskCopilotPanel_useAskCopilotSendMessage_note$key = {
  readonly " $data"?: AskCopilotPanel_useAskCopilotSendMessage_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskCopilotPanel_useAskCopilotSendMessage_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskCopilotPanel_useAskCopilotSendMessage_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "4c55749f82ca47bd2ab65f79dc519ca7";

export default node;
